import { Edit } from "../../../components/base-requirements/Edit.tsx";
import { useParams } from "react-router-dom";

export default function BaseRequirementsIDPage() {
  const params = useParams();

  return (
    <div className="w-full h-full p-8">
      <Edit id={params.id!} />
    </div>
  );
}
